import shared from './shared';

/**
 * Sets up Roomba Mirage Scenario
 * - `MIRAGE_SCENARIO=roomba yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const { company, locations } = shared(server);

  const subscription = server.create('subscription', 'asStandard', {
    company,
    app: 'rooms',
  });

  const roombaCompany = server.create('roomba/company', 'withGoogleCalendar', {
    id: company.id,
  });
  const roombaLocation = server.create('roomba/location', { company: roombaCompany });

  return {
    company,
    locations,
    subscription,
    roombaCompany,
    roombaLocation,
  };
}
